import { getAPI } from "../../api";
import { REACT_APP_CANDIDATE } from "../../utils/common";


export async function getDetails(Id: string | null){
    // let newId = '1a0a6a61-9740-4041-b553-ef9b0bb92e15'
    const Details = getAPI( REACT_APP_CANDIDATE + '/api/' + `${Id}`)
    return Details
}

